import React from 'react';
import SpeakerBlock from './SpeakerBlock';
import ChapterRibbon from './ChapterRibbon';
import EventDate from './parts/EventDate';
import EventMeta from './parts/EventMeta';

// Layout: an optional chapter tab on top of the agenda row, which composes the
// shared parts. Two modes:
//   href       -> real navigation card (chapter): native new-tab / right-click work.
//   onActivate -> action card (forum): a button that runs a callback (opens the modal).
// hideSpeakers drops the speaker column (e.g. the speaker's own page, where it's redundant).
const EventCard = ({ event, href, onActivate, hideSpeakers = false }) => {
    const rowClass = `agenda-row${hideSpeakers ? ' agenda-row--no-speaker' : ''}`;
    const body = (
        <>
            {event.chapter
                ? <ChapterRibbon name={event.chapter.name} thumbnail={event.chapter.thumbnail} />
                : <ChapterRibbon name="Workshop" icon="users" />}

            <div className={rowClass}>
                <EventDate date={event.date} />

                <div className="agenda-main">
                    <div className="agenda-copy">
                        <h3 title={event.title}>{event.title}</h3>
                        {event.subtitle && <p className="subtitle" title={event.subtitle}>{event.subtitle}</p>}
                        <EventMeta event={event} />
                    </div>

                    {!hideSpeakers && (
                        <div className="agenda-speaker">
                            <SpeakerBlock speakers={event.speakers} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );

    if (href) {
        return <a className="agenda-card" href={href}>{body}</a>;
    }

    const activate = () => onActivate(event);
    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate();
        }
    };

    return (
        <article className="agenda-card" role="button" tabIndex={0} onClick={activate} onKeyDown={onKeyDown}>
            {body}
        </article>
    );
};

export default EventCard;
